import { Outlet, useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import { useState, useEffect } from "react";
import { Sun, Moon } from "lucide-react";

const AdminLayout = () => {
  const navigate = useNavigate();
  const [darkMode, setDarkMode] = useState(
    localStorage.getItem("theme") === "dark"
  );

  const handleLogout = () => {
    localStorage.removeItem("user");
    navigate("/login");
  };

  // Handle theme switching
  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  }, [darkMode]);

  return (
    <div className="flex min-h-screen bg-gray-100 dark:bg-gray-900 transition-colors duration-500">
      <Sidebar />

      <div className="flex flex-col flex-1">
        {/* Topbar */}
        <header className="bg-white dark:bg-gray-800 shadow-md px-6 py-3 flex justify-between items-center transition-colors duration-500 sticky top-0 z-10">
          <h1 className="text-2xl font-bold text-gray-700 dark:text-gray-200">
            Admin Dashboard
          </h1>
          <div className="flex items-center gap-4">
            {/* Theme Toggle */}
            <button
              onClick={() => setDarkMode(!darkMode)}
              className="p-2 rounded-full bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors duration-300"
              aria-label="Toggle Dark Mode"
            >
              {darkMode ? (
                <Sun className="w-6 h-6 text-yellow-400 animate-spin" />
              ) : (
                <Moon className="w-6 h-6 text-indigo-600" />
              )}
            </button>

            {/* Logout */}
            <button
              onClick={handleLogout}
              className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg shadow hover:shadow-lg transition-all duration-300"
            >
              Logout
            </button>
          </div>
        </header>

        {/* Main Content */}
        <main className="flex-1 p-6 overflow-auto transition-colors duration-500 bg-gray-50 dark:bg-gray-900">
          <div className="max-w-7xl mx-auto">
            <Outlet />
          </div>
        </main>

        {/* Footer */}
        <footer className="bg-white dark:bg-gray-800 text-center p-4 text-gray-600 dark:text-gray-400 text-sm shadow-inner transition-colors duration-500">
          © {new Date().getFullYear()} UPSC Dashboard. All rights reserved.
        </footer>
      </div>
    </div>
  );
};

export default AdminLayout;
